// Shared application constants. Add new values here and export them by name
// so consumers can import only what they need.
const constants = Object.freeze({
    KEY_TAKEAWAYS_DISPLAY_LIMIT: 100,
});

// Keep a default export for any consumers that prefer constants.VALUE syntax.
export default constants;
